import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Nav, NavItem, NavLink } from "reactstrap";
import PropTypes from "prop-types";
import Profile from "../../assets/images/profile-img.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getPatients, updatePatientArchieve, updatePatientById } from "../../api/patient";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";
import { decryptData } from "../../utils/helper";
import { calculateAge } from "../../utils/DateSupport";
import Search from "../../components/InputFields/Search";
import CustomPagination from "../../components/Pagination/CustomPagination";
import { DepartmentOptions, columnOptions, medicaidOptions, yesNoMedicaidOptions, yesNoOptions } from "./Constant";
import "./PatientProfile.css";
import { AI_CARE, ITEMS_PER_PAGE } from "../../utils/constants";
import { applyFilters, decryptPatientData } from "../../utils/common";
import moment from "moment";
import MultiSelectCheckbox from "../../components/InputFields/MultiSelectWithCheckboc";
import { getStaffsByOrgId } from "../../api/User";
import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import TextInput from "../../components/InputFields/TextInput";
import DynamicFilterDropdown from "../../components/Filters/Filter";
import { deleteFilter } from "../../api/filters";
import ImportPatient from "./addpatient/ImportPatient";
import Typography from '@mui/material/Typography';
import { resetCurrentPage, setCurrentPage, setCustomFilteredPatients, setListFilter, setSearchKey, setSelectedCustomFilter, setSortBy } from "../../context/reducers/pagination";
import noProfileImg from "../../../src/assets/images/noImage.jpg";

function PatientList({ direction }) {
  let token = useSelector(state => state.userReducer.token);
  let user = useSelector((state) => state.userReducer.user);
  localStorage.setItem("prevRoute", window.location.pathname);
  const [dropdowntwo, setDropdowntwo] = useState(false);
  const [expandedOrg, setExpandedOrg] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState(columnOptions.filter(option => option.value !== "discharged_status" && option.value !== "stage").map(option => option.value));
  const toggleone = () => setDropdowntwo((prevState) => !prevState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patients, setPatients] = useState([]);
  const listFilter = useSelector((state) => state.paginationReducer.listFilter);
  const searchKey = useSelector((state) => state.paginationReducer.searchKey);
  const currentPage = useSelector(state => state.paginationReducer.currentPage);
  const [rowsPerPage] = useState(ITEMS_PER_PAGE);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [dropdownState, setDropdownState] = useState({});
  const [selectedCheckbocOption, setSelectedCheckboxOption] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [staffList, setStaffOptions] = useState([]);
  const [editingPatient, setEditingPatient] = useState({});
  const [patientNote, setNote] = useState('');
  const { getConfirmation } = useConfirmDialog();
  const [countofList, setCountOfList] = useState();
  const [houseIncome, setHouseIncome] = useState({});
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [showImportModel, setShowImportModel] = useState(false);
  const selectedCustomFilter = useSelector((state) => state.paginationReducer.selectedCustomFilter);
  const customFilteredPatients = useSelector((state) => state.paginationReducer.customFilteredPatients);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const sortBy = useSelector((state) => state.paginationReducer.sortBy);
  const [initialHouseIncome, setInitialHouseIncome] = useState({});
  const [householdIncome, setHouseholdIncome] = useState({});

  const breadcrumbs = [
    <Typography key="2"  sx={{ color: 'text.primary', fontSize: '1.4rem'}}
    >
      Patient List
    </Typography>
  ];

  const getStaffList = async (page, limit, searchKey = "") => {
    let res;
    try {
      setIsLoading(true);
      // setSearch(searchKey);
      res = await getStaffsByOrgId({ dispatch, token, page, limit, searchKey,  orgId: localStorage.getItem("currentOrgId"), dataLimit: "all", currentHospitalId : localStorage.getItem("currentHospitalId") });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        const dropdownData = responseData?.items?.map((staff) => ({
          label: `${staff.firstName} ${staff.lastName}`,
          value: staff._id
        }));
        setStaffOptions(dropdownData);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const togglefour = (filterId) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [filterId]: !prevState[filterId]
    }));
  };

  useEffect(() => {
    getStaffList();
  }, []);

  const handleStaffSelect = async (patientId, value) => {
    let res;
    try {
      const payload = { patientId, staffId: value || null };
      setIsLoading(true);
      res = await updatePatientById({ payload, dispatch, token, patientId });
      if (res?.status == "SUCCESS") {
        setIsLoading(false);
        await getPatientList();
        success(res?.message);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
  };

  const [sortedDropKey, setSortedDropKey] = useState();


  const getPatientList = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getPatients({ dispatch, token, listFilter, orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId") });
      if (res?.status === "SUCCESS") {
        const responseData = decryptData(res.data);
        setCountOfList(responseData?.filterCounts);
        if (responseData?.list) {
          const decryptedPatients = await Promise.all(
            responseData.list.map(async (patient) => {
              return decryptPatientData(patient);
            })
          );
          const decryptedAllPatients = await Promise.all(
            responseData.allPatients.map(async (patient) => {
              return decryptPatientData(patient);
            })
          );
          setPatients({ ...responseData, items: decryptedPatients,allPatients: decryptedAllPatients });
          setFilteredPatients(decryptedPatients);
          if (selectedCustomFilter?.length > 0) {
            const customFiltered = applyFilters(selectedCustomFilter, decryptedPatients, "Patient");
            dispatch(setCustomFilteredPatients(customFiltered));
          }
        }
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const getCustomFilterCount = (filter) => {
    if (!filter?.filters || !Array.isArray(patients?.allPatients)) {
      return 0;
    }
    const filteredPatients = applyFilters(filter.filters, patients.allPatients, "Patient");
    return filteredPatients.length;
  };

  const handleExpand = (id) => {
    setExpandedOrg(prev => prev.includes(id) ? prev.filter(orgId => orgId !== id) : [...prev, id]);
  };

  useEffect(() => {
    if(listFilter !== ""){
      getPatientList();
    }
  }, [listFilter]);

  useEffect(() => {
    if (patients?.items) {
      let tempPatients = [...patients.items];

      // 1. Apply Custom Filters
      if (selectedCustomFilter?.length > 0) {
        tempPatients = applyFilters(selectedCustomFilter, tempPatients, "Patient");
      }

      // 2. Apply Search Filter
      if ((searchKey || "").trim() !== "") {
        const lowercasedSearchKey = searchKey.toLowerCase();
        tempPatients = tempPatients.filter((patient) => {
          const patientName = patient?.name?.text?.toLowerCase() || "";
          const patientTelecom = patient?.telecom?.map(t => t?.value?.toString()?.toLowerCase()).join(" ") || "";
          const patientLocationCity = patient?.address?.city?.toLowerCase() || "";
          const patientLocationState = patient?.address?.state?.toLowerCase() || "";

          return (
            patientName.includes(lowercasedSearchKey) ||
            patientTelecom.includes(lowercasedSearchKey) ||
            patientLocationCity.includes(lowercasedSearchKey) ||
            patientLocationState.includes(lowercasedSearchKey)
          );
        });
      }

      // 3. Apply Sort
      if (sortBy.column) {
        const sortDirection = sortBy.desc ? 1 : -1;
        tempPatients.sort((a, b) => {
          let valA = "";
          let valB = "";

          if (sortBy.column === "name") {
            valA = a?.name?.text?.toLowerCase() || "";
            valB = b?.name?.text?.toLowerCase() || "";
          }
          // You can extend sorting for other columns if needed

          return valA.localeCompare(valB) * sortDirection;
        });
      }

      // 4. Set Filtered Patients
      setFilteredPatients(tempPatients);
    }
  }, [patients, searchKey, sortBy, selectedCustomFilter]);

  const handlePagination = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleColumn = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
  if (location.state?.listFilter) {
    dispatch(setListFilter(location.state.listFilter));
    navigate(location.pathname, { replace: true }); // clear state to avoid repeating
  }
}, [location.state, dispatch, navigate, location.pathname]);

  const handleFilter = (status) => {
    dispatch(setListFilter(status));
    dispatch(resetCurrentPage());
    dispatch(setSelectedCustomFilter(null));
  };

  const activeCustomFilterTitle = useMemo(() => {
    if (selectedCustomFilter?.length > 0 && patients?.filterList?.length > 0) {
      const matchedFilter = patients.filterList.find(filter => {
        return JSON.stringify(filter.filters) === JSON.stringify(selectedCustomFilter);
      });
      return matchedFilter?.title || null;
    }
    return null;
  }, [selectedCustomFilter, patients]);

  const handleSort = (column) => {
    const newSortBy = {
      column,
      desc: sortBy.column === column ? !sortBy.desc : false
    };
    dispatch(setSortBy(newSortBy));
  };

  const handleSearch = (e) => {
    dispatch(setSearchKey(e.target.value)); // update searchKey in Redux
    dispatch(resetCurrentPage()); // reset to page 1 on new search
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedPatients = filteredPatients && filteredPatients?.slice(startIndex, endIndex);

  const getAgesForHouseholdMembers = (members) => {
    if (!members || members.length === 0) return '';

    const ages = members
      .map(member => member.dob)
      .filter(dob => dob)
      .map(dob => calculateAge(moment(dob).format("DD-MM-YYYY")))
      .join(' | ');

    return ages;
  };

  const getRelationshipWithAges = (members) => {
    if (!members || members.length === 0) return '';
    return members.map((member, idx) => {
      const dob = member.dob;
      const relationship = member.relationship || "Member";
      if (!dob) return <div key={idx}>{relationship}: N/A</div>;
      const age = calculateAgeFormatted(moment(dob, "MM-DD-YYYY").toDate());
      return (
        <div key={idx}>
          {relationship}: {age}
        </div>
      );
    });
  };

  const calculateAgeFormatted = (dob) => {
    const now = moment();
    const birth = moment(dob);
    const years = now.diff(birth, 'years');
    if (years === 0) return "less than one year";
    return `${years} years`;
  };

const handleSelectAll = () => {
  if (isSelectAll) {
    setSelectedCheckboxOption([]);
  } else {
    const selectableIds = paginatedPatients
      .filter(patient => !patient.archieve) // Exclude archived
      .map(patient => patient._id);
    setSelectedCheckboxOption(selectableIds);
  }
  setIsSelectAll(!isSelectAll);
};


  const handleSelect = (id) => {
    if (selectedCheckbocOption.includes(id)) {
      setSelectedCheckboxOption(selectedCheckbocOption.filter(item => item !== id));
    } else {
      setSelectedCheckboxOption([...selectedCheckbocOption, id]);
    }
  };

  useEffect(() => {
    // Update isSelectAll based on the current state of selectedOption and paginatedPatients
    const allIds = paginatedPatients?.map(patient => patient._id);
    setIsSelectAll(allIds?.length > 0 && allIds.every(id => selectedCheckbocOption.includes(id)));
  }, [selectedCheckbocOption, paginatedPatients]);

  const isChecked = (id) => selectedCheckbocOption.includes(id);

  const handleArchieve = async () => {
    let res;
    try {
      let statusArchieve = listFilter === "archieve" ? false : true;
      setIsLoading(true);
      res = await updatePatientArchieve({ values: { patientIds: selectedCheckbocOption, archieve: statusArchieve }, dispatch, token });
      if (res?.status === "SUCCESS") {
        await getPatientList();
        setIsLoading(false);
        success(res?.message);
        setIsSelectAll(false);
        setSelectedCheckboxOption([]);
        // setCurrentPage(1);
        dispatch(resetCurrentPage());
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleEditClick = (patientId) => {
    setEditingPatient((prevState) => ({ ...prevState, [patientId]: true })); // Enable editing mode for specific patient
  };

  useEffect(() => {
  const initialIncome = {};
  filteredPatients.forEach((patient) => {
    initialIncome[patient._id] = patient.houseHoldIncome;
  });
  setInitialHouseIncome(initialIncome);
  setHouseIncome(initialIncome);
}, [filteredPatients]);

  const handleSaveClick = async (patientId, payload) => {
    // ✅ Skip householdIncome comparison if it's not part of the payload
    if (
      Object.prototype.hasOwnProperty.call(payload, "houseHoldIncome") &&
      initialHouseIncome[patientId] === payload.houseHoldIncome
    ) {
      if (Object.keys(payload).length === 1) {
        return;
      }
    }
    let res;
    try {
      setIsLoading(true);
      res = await updatePatientById({ payload, dispatch, token, patientId });
      if (res?.status === "SUCCESS") {
        await getPatientList();
        setIsLoading(false);
        success(res?.message);
        setEditingPatient(false);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleNoteChange = (patientId, value) => {
    setNote((prevState) => ({ ...prevState, [patientId]: value })); // Update note text for specific patient
  };

  const handleDeleteClick = async (patientId, payload) => {
    let res;
    try {
      const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure want to Delete Note`
      });
      if (confirmed) {
        setIsLoading(true);
        res = await updatePatientById({ payload, dispatch, token, patientId });
        if (res?.status === "SUCCESS") {
          setIsLoading(false);
          success(res?.message);
          setEditingPatient(false);
          setNote("");
          await getPatientList();
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleHouseIncomeChange = (patientId, value) => {
    // If the input is cleared, set the value to 0
    const numericValue = value === "" ? "" : Number(value);
    if (!isNaN(numericValue) && numericValue >= 0) {
      setHouseIncome((prevState) => ({
        ...prevState,
        [patientId]: numericValue
      }));
    }
  };

  const applyPatientFilters = (filters) => {
    setSelectedFilters(filters); // <- Save the filters globally
    let result = patients?.items;
    const filteredPatients = applyFilters(filters, result, "Patient");
    setFilteredPatients(filteredPatients);
  };

  const handleFilterSelect = (filter) => {
    const newFilters = filter.filters;
    const fullList = patients?.items || [];
    const filteredList = applyFilters(newFilters, fullList, "Patient");
    dispatch(setListFilter("all"));
    dispatch(setSelectedCustomFilter(newFilters));
    dispatch(setCustomFilteredPatients(filteredList));
    dispatch(resetCurrentPage());
  };

  const  handleFilterDelete  = async(id) =>{
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName: "",
      actionBtnTitle: "Yes",
      message: `Are you sure you want to delete Filter?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {filterId: id};
            setIsLoading(true);
            res = await deleteFilter({values, dispatch, token});
            if (res?.status === "SUCCESS") {
                setIsLoading(false);
                await getPatientList();
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
      }
  };

  const calculateAgeDisplay = (birthDate) => {
    if (!birthDate) return "";
    const birth = moment(birthDate);
    const now = moment();
    const years = now.diff(birth, "years");
    if (years >= 1) {
      return `${years} ${years === 1 ? "year" : "years"}`;
    }
    return "Less than one year";
  };

  return (
    <Fragment>
      {isLoading ? <Loader /> : null}
      {showImportModel && <ImportPatient setShowImportModel={setShowImportModel} showImportModel={showImportModel} getPatientList={getPatientList}/>}
      <div className="dashboard_container patient_list_container table_listing_color  patient_listing_admin">
        <div className="d-flex justify-content-between align-items-end main-header-block">
          <div className="left_header d-flex justify-content-between align-items-center">
            <h2 className="home-title">Patients</h2>
          </div>
          <div className="right_header">
            <div className="d-flex justify-content-start align-items-center patient_list_header gap-3">
              <MultiSelectCheckbox
                className="all_columns_blk"
                options={columnOptions}
                selectedOptions={selectedOption}
                onChange={handleColumn}
                placeholder="All Columns"
              />
              <DynamicFilterDropdown onFilterChange={applyPatientFilters} type="Patient" selectedFilters={selectedCustomFilter} columnOptions={columnOptions} staffList={staffList} refetch={getPatientList}/>
              <Search
                value={searchKey}
                onChange={(e) => handleSearch(e)}
              />
              {<button className="new_patient archeive" disabled={selectedCheckbocOption.length === 0} onClick={() => handleArchieve()}>{listFilter === "archieve" ? "Unarchive" : "Archive"}</button>}
              <button
              className="new_patient"
              onClick={() => {
                const prevRoute = localStorage.getItem("prevRoute");
                const isRouteMode4 = prevRoute === "	/app/admin-application";
                localStorage.setItem("isEditMode3", JSON.stringify(isRouteMode4));
                navigate("/clinic/add-patient");
              }}
            >Add New Patients</button>
            <button className="new_patient" onClick={() => setShowImportModel(true)}>Import Patients</button>
            </div>
          </div>
        </div>
        <div className="horizontal_divider"></div>
        <div className="row m-0">
          <div className="col-lg-2 col-md-12 nav_side">
            <Nav vertical className="gap-2">
              <h4 className="main-views m-2">Patient</h4>
              <NavItem className={(listFilter === "assigned-me" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("assigned-me")} className="d-flex justify-content-between dashbord_nav mb-2">
                  Assigned to me
                  <span>{countofList?.assignedMe ? countofList?.assignedMe : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "new" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("new")} className="d-flex justify-content-between dashbord_nav mb-2">
                  New Patient
                  <span>{countofList?.newPatient ? countofList?.newPatient : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "all" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("all")} className="d-flex justify-content-between dashbord_nav mb-2">
                  All Patient
                  <span>{countofList?.allPatient ? countofList?.allPatient : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "InProcess" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("InProcess")} className="d-flex justify-content-between dashbord_nav mb-2">
                Enrollment In Process
                  <span>{countofList?.InProcess}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "completed" && !activeCustomFilterTitle)? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("completed")} className="d-flex justify-content-between dashbord_nav mb-2">
                  Enrollment Completed
                  <span>{countofList?.enrollmentCompleted ? countofList?.enrollmentCompleted : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "Not Approved" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("Not Approved")} className="d-flex justify-content-between dashbord_nav mb-2">
                  Patient Not Approved
                  <span>{countofList?.NotApproved ? countofList?.NotApproved : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "Approved" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("Approved")} className="d-flex justify-content-between dashbord_nav mb-2">
                  Patient Approved
                  <span>{countofList?.Approved ? countofList?.Approved : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "ai-verified" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("ai-verified")} className="d-flex justify-content-between dashbord_nav mb-2">
                Medicaid Eligibility
                  <span>{countofList?.aiCare ? countofList?.aiCare : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "archieve"  && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink href="#" onClick={() => handleFilter("archieve")} className="d-flex justify-content-between dashbord_nav mb-2">
                  Archived
                  <span>{countofList?.archieve ? countofList?.archieve : 0}</span>
                </NavLink>
              </NavItem>
              {patients?.filterList?.length > 0 && <h4 className="main-views mt-2 mb-2 d-flex justify-content-between align-items-center">Custom Filters</h4>}
            {patients?.filterList?.length > 0 && patients?.filterList.map((filter, index) => (
              <NavItem   className={`d-flex justify-content-between align-items-center ${activeCustomFilterTitle === filter.title ? 'active' : ''}`}
              key={filter?._id}>
                <NavLink
                  href="#"
                  className="d-flex justify-content-between dashbord_nav mb-2"
                  onClick={() => { handleFilterSelect(filter);  }}
                >
                  {filter.title} ({getCustomFilterCount(filter)})
                  </NavLink>
                <Dropdown
                  isOpen={dropdownState[filter._id] || false}
                  toggle={() => togglefour(filter._id)}
                  >
                  <DropdownToggle caret size="xl" className="filter_block_blk">
                    <i className="fa fa-ellipsis-v"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      className="d-flex gap-2 drop_block_content align-items-center"
                      onClick={() => handleFilterDelete(filter._id)}
                    >
                      Delete View
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </NavItem>
            ))}
            </Nav>
          </div>
          <div className="col-lg-10 col-md-12 table_space incone">
            <div className="table-responsive">
              <table>
                <thead>
                  <tr className="header_table">
                    <th className="check_in p-2">
                      <Form className="all_check">
                        <FormGroup
                          check
                          inline
                        >
                          <Input
                            type="checkbox"
                            checked={isSelectAll}
                            onChange={handleSelectAll}
                          />
                        </FormGroup>
                      </Form>
                    </th>
                    <th className="p-0"></th>
                    {(selectedOption.length !== 0 && selectedOption.includes("patient_name")) && <th onClick={() => handleSort("name")}>Patient Name <i className='fas fa-sort'></i></th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("medicaid_eligibility")) &&<th>Medicaid Eligibility</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("household_salary")) && <th>Annual Household Income</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("assigned_to")) && <th>Assigned To</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("state")) && <th>State</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("coverage")) && <th>Coverage</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("department_approval")) && <th>Department Approval</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("pregnant")) && <th>Pregnant</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("disable")) && <th>Disable</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("group_eligibility")) &&<th>Eligibility Group</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("discharged_status")) && <th>Discharged Status</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("stage")) && <th>DOA</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("household_members")) && <th>Household Members</th>}
                    <th></th>
                  </tr>
                </thead>
                {paginatedPatients?.length > 0 ? paginatedPatients?.map((patient, index) => (
                  <tbody key={patient?._id}>
                    <tr><td colSpan="9" height="5" className="bg_light"></td></tr>
                    <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                      <td className="check_in p-2">
                        <Form>
                          <FormGroup check inline>
                            <Input
                              type="checkbox"
                              checked={isChecked(patient._id)}
                              disabled={listFilter !== "archieve" ?  patient?.archieve : false}
                              onChange={() => handleSelect(patient._id)}
                            />
                          </FormGroup>
                        </Form>
                      </td>
                      <td className="check_in p-0 color_change" onClick={() => handleExpand(patient?._id)}><i className={expandedOrg.includes(patient?._id) ? 'fas fa-caret-down' : 'fas fa-caret-right'}></i></td>
                      {(selectedOption.length !== 0 && selectedOption.includes("patient_name")) && (
                        <td>
                          <div className="d-flex flex-column gap-2">
                          <Link
                            to="/clinic/patient-profile"
                            className="title_name"
                            state={{ patientData: patient?._id }}
                          >
                            {patient?.name?.text}
                          </Link>
                          {calculateAgeDisplay(patient?.birthDate)} | {patient?.gender} | {patient?.address?.state}
                          {patient?.archieve ? (
                            <button className="pending_blk" style={{ color: "red" }}>
                              Archived
                            </button>
                          ) : null}
                          </div>
                        </td>
                      )}
                      {(selectedOption.length !== 0 && selectedOption.includes("medicaid_eligibility")) && <td><button className={`btn_status ${patient?.houseHoldIncome === null ? "None" : patient?.system_ai_care === "Yes" || patient?.houseHoldIncome === 0 ? "yes" : patient?.system_ai_care === "No" ? "no" : ""}`}>{AI_CARE} : {patient?.houseHoldIncome === null ? "None" : patient?.system_ai_care === "Yes" || patient?.houseHoldIncome === 0 ? "Yes" : patient?.system_ai_care === "No" ? "No" : "None"}</button>
                      <br/>
                      {patient?.houseHoldIncome !== null && patient?.applied_fpl_percentage && patient?.eligibility_group_applied && patient?.applied_income_limit &&
                      <div className="poverty-limit">
                        <p>FPL : {patient?.applied_fpl_percentage} %</p>
                        <p>Group : {patient?.eligibility_group_applied}</p>
                        <p>Limit : {Math.round(patient.applied_income_limit)} USD</p>
                        </div>}
                        </td>}
                        {(selectedOption.length !== 0 && selectedOption.includes("household_salary")) && <td>
                          <TextInput
                            keyField={"householdIncome"}
                            required={false}
                            type="text"
                            value={
                              houseIncome[patient?._id] !== undefined
                                ? houseIncome[patient?._id]
                                : (patient?.houseHoldIncome !== undefined ? patient.houseHoldIncome : "")
                            }
                            onBlur={() =>
                              handleSaveClick(patient?._id, { houseHoldIncome: houseIncome[patient?._id] !== undefined ? houseIncome[patient?._id] : patient?.houseHoldIncome || 0 })
                            }
                            onChange={(e) => handleHouseIncomeChange(patient?._id, e.target.value)}
                          />
                          </td>}
                      {(selectedOption.length !== 0 && selectedOption.includes("assigned_to")) && <td>
                      <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                          <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={patient?.staffId || '' }
                            onChange={(e) => handleStaffSelect(patient._id, e.target.value)} // Assign staff to this patient
                          >
                            <MenuItem value="">
                              <em>None </em>
                            </MenuItem>
                            {staffList?.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          </FormControl>
                        </td>}
                        {(selectedOption.length !== 0 && selectedOption.includes("state")) && <td>{patient?.address?.state}</td>}
                      {(selectedOption.length !== 0 && selectedOption.includes("coverage")) && <td>
                        <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                          <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={patient?.coverage}
                            onChange={(e) => handleSaveClick(patient._id, {"coverage":e.target.value})} // Assign staff to this patient
                          >
                          {yesNoOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        </FormControl></td>}
                      {(selectedOption.length !== 0 && selectedOption.includes("department_approval")) && <td>
                      <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                        <Select
                              labelId="demo-select-small-label"
                              id="demo-select-small"
                              value={patient?.departmentAprvlStatus}
                              onChange={(e) => handleSaveClick(patient._id, {"departmentAprvlStatus":e.target.value === "" ? null : e.target.value})}
                            >
                              <MenuItem value="">
                                <em>None </em>
                              </MenuItem>
                              {DepartmentOptions?.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                        </Select>
                        </FormControl></td>}
                          {(selectedOption.length !== 0 && selectedOption.includes("pregnant")) && (
                            <td>
                              {patient?.gender === "Male" ? (
                                <span style={{ margin: '8px', display: 'inline-block' }}>N/A</span>
                              ) : (
                                <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                                  <Select
                                    labelId="demo-select-small-label"
                                    id="demo-select-small"
                                    value={patient?.isPregnant}
                                    onChange={(e) =>
                                      handleSaveClick(patient._id, { isPregnant: e.target.value })
                                    }
                                  >
                                    {yesNoOptions?.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              )}
                            </td>
                          )}
                          {(selectedOption.length !== 0 && selectedOption.includes("disable")) && <td>
                          <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                          <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={patient?.isDisable}
                            onChange={(e) => handleSaveClick(patient._id, {"isDisable":e.target.value})} // Assign staff to this patient
                          >
                          {yesNoOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        </FormControl>
                          </td>}
                       {(selectedOption.length !== 0 && selectedOption.includes("group_eligibility")) && (
                          <td>
                            {(Array.isArray(patient?.medicaidElegibitlyGroup) && patient.medicaidElegibitlyGroup.length > 0)
                              ? patient.medicaidElegibitlyGroup.join(", ")
                              : " "}
                          </td>
                        )}
                        {(selectedOption.length !== 0 && selectedOption.includes("discharged_status")) && <th><FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                          <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={patient?.discharged_status}
                            onChange={(e) => handleSaveClick(patient._id, {"discharged_status":e.target.value === "" ? null : e.target.value})} // Assign staff to this patient
                          >
                          <MenuItem value="">
                            <em>None </em>
                          </MenuItem>
                          {yesNoOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        </FormControl></th>}
                      {(selectedOption.length !== 0 && selectedOption.includes("stage")) && <td>{moment(patient?.doa).format("MM-DD-YYYY")}</td>}
                     {(selectedOption.length !== 0 && selectedOption.includes("household_members")) && (
                        <td className="d-flex flex-column gap-2 align-items-center">
                          <div>Size: {patient?.houseHoldSize || patient?.relationship?.length || 0}</div>
                          <div className="text-center d-flex flex-column">
                            {getRelationshipWithAges(patient?.relationship)}
                          </div>
                        </td>
                      )}
                      {(selectedOption.length !== 0 && selectedOption.includes("group_eligibility")) &&<td>
                        </td>}
                      <td>
                        <button onClick={() => { navigate("/clinic/patient-profile", { state: { patientData: patient?._id } }); }} style={{ background: "none" }} >
                          <Link className="d-flex flex-column gap-1 align-items-center anchor">
                            <i className="fa fa-external-link"></i>View Details
                          </Link>
                        </button>
                      </td>
                    </tr>
                    {expandedOrg.includes(patient?._id) && <tr className="first_block">
                      <td colSpan={15}>
                        <div className="patient_summery_blockk px-3">
                          <div className="row">
                            <div className="col-md-2">
                              <div className="d-flex align-items-center flex-column blovk">
                              <h5 className="summary_block mb-4">Patient Summary</h5>
                                <img className="patient_profile_summary m-0" src={patient?.profile_image ? patient?.profile_image : noProfileImg} alt="patient_profile" />
                                <button className="view_summery" onClick={() => { navigate("/clinic/add-patient", { state: { patientDetails: patient } }); }}>Edit Details</button>
                              </div>
                            </div>
                            <div className="col-md-8">
                              <div className="row mt-4">
                                <div className="col-md-4 mb-3">
                                  <p className="data_summary">Phone Number : <span>{patient?.telecom[1]?.value}</span></p>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <p className="data_summary">Emergency Name : <span>{patient?.emergencyContacts?.name}</span></p>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <p className="data_summary">Emergency Contact : <span>{patient?.emergencyContacts?.phone}</span></p>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <p className="data_summary">Primary Coverage : <span>{patient?.insuranceDetails?.company}</span></p>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <p className="data_summary">Medicaid Enrollment Status : <span>{patient?.medicaidEnrollmentStatus}</span></p>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <p className="data_summary">Medicaid Enrollment Date : <span>{moment().format("MM-DD-YYYY")}</span></p>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <p className="data_summary">Secondary Coverage : <span>{patient?.insuranceDetails?.alternateCompany}</span></p>
                                </div>
                              </div>
                              <div className="note_block mt-3">
                            <p className="data_summary">Note :</p>
                            <div className="d-flex align-items-center gap-2">
                              <Form className="text_block">
                                <Input
                                  id="exampleText"
                                  name="text"
                                  type="textarea"
                                  className="text_area_blk"
                                  value={editingPatient[patient._id] ? patientNote[patient._id] : patient?.patientNote || ''}
                                  onClick={() => handleEditClick(patient._id)} // Enable editing when clicking on the input
                                  onChange={(e) => handleNoteChange(patient._id, e.target.value)}
                                />
                              </Form>
                              <div className="d-flex gap-3">
                                {editingPatient[patient._id] ? (
                                  <i
                                    className="fa fa-floppy-disk"
                                    onClick={() => handleSaveClick(patient._id, { patientNote: patientNote[patient._id] })}
                                    style={{ cursor: 'pointer' }}
                                  ></i>
                                ) : (
                                  <i
                                    className="fa fa-edit"
                                    onClick={() => handleEditClick(patient._id)}
                                    style={{ cursor: 'pointer' }}
                                  ></i>
                                )}
                                {patient?.patientNote ? (
                                  <i
                                    className="fas fa-trash-alt"
                                    onClick={() => handleDeleteClick(patient._id, { patientNote: '' })}
                                    style={{ cursor: 'pointer' }}
                                  ></i>
                                ) : null}
                              </div>
                            </div>
                          </div>
                            </div>
                            <div className="col-md-2">
                              <div className="mt-4">
                              <div className="col-md-12 mb-3">
                                  <button className="archeive_blk" onClick={(e) => handleSaveClick(patient._id, { "archieve": !patient?.archieve })}>{patient?.archieve ? "Unarchive" : "Archive"}</button>
                                </div>
                                <div className="col-md-12">
                                  <button
                                    className="start_blk"
                                    disabled={
                                      !patient?.staffId ||
                                      patient?.system_ai_care === "No" ||
                                      patient?.system_ai_care === "None" ||
                                      patient?.archieve === true ||
                                      patient?.applications?.some(app => app.status === "InProcess")
                                    }
                                    onClick={() => {
                                      navigate("/app/start-application", { state: { patientDetails: patient } });
                                    }}
                                  >
                                    Start Application
                                  </button>
                                  {(
                                    !patient?.staffId ||
                                    patient?.system_ai_care === "No" ||
                                    patient?.system_ai_care === "None" ||
                                    patient?.archieve === true ||
                                    patient?.applications?.some(app => app.status === "InProcess")
                                  ) && (
                                    <div className="disabled-reason" style={{ marginTop: "10px", color: "black", fontSize: "12px" }}>
                                      {!patient?.staffId && <p>To start application assign patient to staff member.</p>}
                                      {patient?.system_ai_care === "No" && <p>Application cannot be initiated. Patient is not eligible for Medicaid</p>}
                                      {patient?.system_ai_care === "None" && <p>Application cannot be initiated. Patient is not eligible for Medicaid</p>}
                                      {patient?.archieve === true && <p>Patient is Archived</p>}
                                      {patient?.applications?.some(app => app.status === "InProcess") && <p>Application cannot be initiated. Patient application already is In-Process</p>}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </td>
                    </tr>}
                    <tr><td colSpan="9" height="5" className="bg_light"></td></tr>
                  </tbody>
                )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
              </table>
            </div>
            <CustomPagination tableData={filteredPatients?.items} totalPages={filteredPatients?.totalPages} totalRows={filteredPatients?.length} rowsPerPage={ITEMS_PER_PAGE} page={currentPage} handlePage={handlePagination} />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

PatientList.propTypes = {
  direction: PropTypes.oneOf([20, 10, 20, 20])
};

export default PatientList;
